import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AppSettings } from 'src/app/app.settings';
import { CustomerService } from 'src/app/core/services/customer.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticateService } from 'src/app/core/services/authenticate.service';
import { AppData } from 'src/app/app.data';
import { Settings } from 'src/app/app.settings.model';
import { SelectListItem } from 'src/app/core/models/select-list-item';
import { Location } from '@angular/common';

@Component({
  selector: 'app-select-business',
  templateUrl: './select-business.component.html',
  styleUrls: ['./select-business.component.scss']
})
export class SelectBusinessComponent implements OnInit, AfterViewInit {

  settings: Settings;
  shouldSelectBusiness: boolean = true;
  businessList: SelectListItem[];

  constructor(private appSettings: AppSettings,
    private customerService: CustomerService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private location: Location,
    private authService: AuthenticateService,
    private appData: AppData) {
    this.settings = appSettings.settings;
  }

  ngOnInit() {
    
    if(this.appData.newCustomerBusinessList && this.appData.newCustomerBusinessList.length > 0){
      this.businessList = this.appData.newCustomerBusinessList;
    
    } else{
      this.customerService.getUserBusiness().subscribe(result => {
        const data = result.Data;
        this.shouldSelectBusiness = data.shouldSelectBusiness;
        this.businessList = data.businessList;
  
        // if additional fields are the same in all businesses take the first business id and continue to new customer page.
        if (this.shouldSelectBusiness === false) {
          const businessID = this.businessList && +this.businessList[0].Value; 
          this.gotoNewCustomer(businessID);
        } 
      });
    }    
  }

  ngAfterViewInit() {
    this.settings.loadingSpinner = false;
  }

  gotoNewCustomer(businessID:number){    
    this.appData.newCustomerBusinessID = businessID;
    this.router.navigate(['/new-customer']);
  }

  onCancel(event){
    // this.location.back();
    this.router.navigate(['/scheduler']);
  }

}
